// Configure compat BEFORE any component imports
import './setup-compat';

import { createApp } from 'vue';
// @ts-ignore
// eslint-disable-next-line no-unused-vars
import { router, store, app, vars, nprogress, helpers, configureApp } from './config/vue';

const vueApp = createApp(app);

// @ts-ignore
configureApp(vueApp);

vueApp.config.globalProperties.$main = vueApp;
vueApp.config.globalProperties.$vars = vars;
vueApp.config.globalProperties.$colors = vars.colors;

vueApp.mount('#app');
